/**
 * @file The one-click approval gate of a schedule staging: what still stops
 * `approvePdfIntakeSchedule` from writing it. A written field is a blocker
 * while it is flagged (a check failed) and the overlay has not overridden its
 * value, or while its mapping sits below `CONFIDENCE_HIGH_THRESHOLD` and the
 * overlay has not set it. Counts cells once per field and mappings once per
 * `mappingKey`, in the words S2's "You — 3 cells, 2 mappings" uses. Pure and
 * shared: the orchestrator counts "waiting on" with it before any overlay
 * exists, and S2's `ApprovalBar` disables Approve on the same counts the
 * server refuses with.
 */
import type { ProcessWholeDocument } from './System.Agent.Extraction.types';
import { CONFIDENCE_HIGH_THRESHOLD } from './System.Agent.Extraction.types';
import { cellStatus } from './cellStatus';
import { stagedScheduleFields } from './stagedScheduleFields';

export function scheduleApprovalBlockers(document: ProcessWholeDocument): { flaggedCells: number; unsureMappings: number } {
    const fields = stagedScheduleFields(document);
    const flaggedCells = fields.filter((field) => !field.edited && cellStatus(field.cell) === 'flagged').length;
    const unsureMappings = new Set(fields
        .filter((field) => !field.mappingDecided && field.mappingConfidence < CONFIDENCE_HIGH_THRESHOLD)
        .map((field) => field.mappingKey)).size;
    return { flaggedCells, unsureMappings };
}
